import { createSlice } from '@reduxjs/toolkit'
import DocumentsServices from '../../services/documentsServices';


const initialState = {
  docTypes: [],
  docTypesDistinte: []
};

const documentTypesSlice = createSlice({
  name: 'docTypes',
  initialState,
  reducers: {
    documentTypesLoaded(state, action) {
      state.docTypes = action.payload;
    },
    documentTypesDistinteLoaded(state, action) {
      state.docTypesDistinte = action.payload;
    },
  },
})

export const { documentTypesLoaded, documentTypesDistinteLoaded } = documentTypesSlice.actions;

export default documentTypesSlice.reducer;

export const fetchDocumentTypesList = () => async (dispatch) => {

  try {
    const respData = await DocumentsServices.getDocumentType();
    if (respData.success) {
      const documentTypesList = respData.responseObject.value.documentTypesList;    

      if(documentTypesList){
        const objectsArray = documentTypesList.map((item) => ({ value: item.id, label: item.name }));
        dispatch(documentTypesLoaded(objectsArray));
      }
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
};

export const fetchDocumentTypesDistinteList = () => async (dispatch) => {

  try {
    const respData = await DocumentsServices.getDocumentTypeDistinte();
    if (respData.success) {
      const documentTypesDistinteList = respData.responseObject.value.documentType_Distintes;    

      if(documentTypesDistinteList){
        const objectsArray = documentTypesDistinteList.map((item) => ({ value: item.id, label: item.name }));
        dispatch(documentTypesDistinteLoaded(objectsArray));
      }
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
}

